import { render } from "./index.vue?vue&type=template&id=0a6b28e4&scoped=true&lang=pug"
import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=0a6b28e4&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-0a6b28e4"

export default script